import { ContentFactory } from './entity/contentFactory';

import type { PrivateBlogCategoryIRepository } from './entity/privateBlogCategoryIRepository';
import type { PrivateBlogIRepository } from './entity/privateBlogIRepository';
import type { Logger } from '@/infra/logger';
import type { WagakoNurseryIApi } from '@/infra/wagakoNurseryIApi';
import type { ContentJson } from '@/types/domain/privateBlog/entities/contentEntity';

import { DomainServiceBase } from '@/domain/domainServiceBase';

export class PrivateBlogDomainService extends DomainServiceBase {
  private wagakoNurseryApi!: WagakoNurseryIApi;

  private privateBlogCategoryRepository!: PrivateBlogCategoryIRepository;

  private privateBlogRepository!: PrivateBlogIRepository;

  private contentFactory = new ContentFactory();

  /**
   * Inject
   * @param wagakoNurseryApi wagakoNurseryApi
   * @param privateBlogCategoryRepository privateBlogCategoryRepository
   * @param privateBlogRepository privateBlogRepository
   */
  public constructor(
    wagakoNurseryApi: WagakoNurseryIApi,
    privateBlogCategoryRepository: PrivateBlogCategoryIRepository,
    privateBlogRepository: PrivateBlogIRepository,
    logger: Logger,
  ) {
    super(logger);
    this.wagakoNurseryApi = wagakoNurseryApi;
    this.privateBlogCategoryRepository = privateBlogCategoryRepository;
    this.privateBlogRepository = privateBlogRepository;
  }

  /**
   * カテゴリ一覧を取得する.
   * @param nurseryId nurseryId.
   */
  public async getCategoryList(nurseryId: string) {
    const result = await this.privateBlogCategoryRepository.getPublicAllList(nurseryId);
    return result;
  }

  /**
   * 限定公開ページ一覧を取得する.
   * @param nurseryId nurseryId.
   * @param token token.
   */
  public async getPrivateBlogList(nurseryId: string, categoryId: string, token: string | null) {
    const result = await this.privateBlogRepository.getPublicListWithKey(
      nurseryId,
      categoryId,
      token,
    );
    return result;
  }

  /**
   * コンテンツをロードする.
   * @param s3Path s3Path.
   * @param nurseryId nurseryId.
   */
  public async loadContent(
    s3Path: string,
    nurseryId: string,
  ) {
    const result = await this.wagakoNurseryApi.loadFileFromS3(s3Path, nurseryId);
    const text = this.wagakoNurseryApi.gunzipText(result.data);
    const json = JSON.parse(text) as ContentJson;
    // 一度entityに入れて情報を補完する（不要かも）
    const ent = this.contentFactory.createFromJsonPvt(json);
    return ent.toJsonData();
  }
}
